/**
 * RemoveDialog - Premium Delete Confirmation Dialog
 * Wrapper around PremiumConfirmDialog for backwards compatibility
 */

import React, { memo } from 'react';
import PremiumConfirmDialog from './premium/PremiumConfirmDialog';

const RemoveDialog = memo(({
  open,
  endpoint,
  itemId,
  onResult,
}) => (
  <PremiumConfirmDialog
    open={open}
    endpoint={endpoint}
    itemId={itemId}
    onResult={onResult}
    onClose={() => onResult?.(false)}
    variant="danger"
  />
));

RemoveDialog.displayName = 'RemoveDialog';

export default RemoveDialog;
